module.exports = __webpack_public_path__ + "img/Group 427320770@2x.290dfcbf.png";